import React, { useEffect, useState } from 'react';
import { FormElement, FormSelector, FormLabel, FormInput, FormNumberInput, DragHandle } from "../components/StyledElements";
import { Handle, Position } from '@xyflow/react';
import { NodeCard } from './NodeCard';
import { CloseButton } from '../components/CloseButton';

export const TextSplittingNodeCard = ({ onAdd = () => { }, style = {} }) => {
  return (
    <NodeCard title="Text Splitting" description="Configure the text splitting method and parameters for chunking your documents." onAdd={onAdd} style={style} />
  )
};

export const TextSplittingNode = ({ id, data }) => {
  console.log("!!! TEXT SPLITTING NODE DATA: ", data);
  const [localData, setLocalData] = useState();

  useEffect(() => {
    console.log("!!! DATA METHOD: ", data.method);
    if (!data) {
      return;
    }
    setLocalData({
      method: data.method || "fixed-size",
      chunkSize: data.chunkSize || 1000,
      overlapSize: data.overlapSize || 200,
      minChunkSize: data.minChunkSize || 100,
      maxChunkSize: data.maxChunkSize || 2000,
      maxSentences: data.maxSentences || 5,
      sentenceOverlap: data.sentenceOverlap || 1,
      maxTokens: data.maxTokens || 500,
      tokenOverlap: data.tokenOverlap || 50,
      windowSize: data.windowSize || 5,
      stepSize: data.stepSize || 2,
      paragraphMaxLength: data.paragraphMaxLength || 1000,
      sentenceMaxLength: data.sentenceMaxLength || 500,
      clusterSize: data.clusterSize || 0,
      nerMaxChunkSize: data.nerMaxChunkSize || 1000,
      cdMinChunkSize: data.cdMinChunkSize || 100,
      cdMaxChunkSize: data.cdMaxChunkSize || 2000,
      customCode: data.customCode || "",
    });
  }, [data]);

  if (!localData) {
    return null; // or a loading indicator
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "10px", border: "1px solid var(--main-border-color)", borderRadius: "8px", backgroundColor: "var(--content-item-bg)" }}>
      <CloseButton onClick={() => {
        data.onDelete(id);
      }} />
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <DragHandle />
        <FormLabel label="Text Splitting" />
        <FormElement>
          <FormLabel label="Method" />
          <FormSelector
            value={localData.method}
            options={[
              { value: "fixed-size", label: "Fixed Size" },
              { value: "recursive", label: "Recursive" },
              { value: "document-based", label: "Document-based" },
              { value: "sentence-based", label: "Sentence-based" },
              { value: "token-based", label: "Token-based" },
              { value: "sliding-window", label: "Sliding Window" },
              { value: "hybrid", label: "Hybrid" },
              { value: "semantic", label: "Semantic" },
              { value: "ner", label: "Named Entity Recognition" },
              { value: "content-density", label: "Content Density" },
              { value: "custom-code", label: "Custom Python Code" },
            ]}
            onChange={(e) => {
              console.log("!!! METHOD CHANGE: ", e.target.value);
              setLocalData({ ...localData, method: e.target.value });
              data.onUpdateData(id, { method: e.target.value });
            }}
          />
        </FormElement>
        {
          localData.method === "fixed-size" && (
            <>
              <FormElement>
                <FormLabel label="Chunk Size (in words)" />
                <FormNumberInput value={localData.chunkSize}
                  onChange={(e) => {
                    console.log("!!! CHUNK SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setLocalData({ ...localData, chunkSize: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, chunkSize: Number(e.target.value) });
                  }} />
              </FormElement>
              <FormElement>
                <FormLabel label="Overlap Size (in words)" />
                <FormNumberInput value={localData.overlapSize}
                  onChange={(e) => {
                    console.log("!!! OVERLAP SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setLocalData({ ...localData, overlapSize: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, overlapSize: Number(e.target.value) });
                  }}
                />
              </FormElement>
            </>
          )
        }
        {
          localData.method === "recursive" && (
            <>
              <FormElement>
                <FormLabel label="Min Chunk Size (in words)" />
                <FormNumberInput value={localData.minChunkSize}
                  onChange={(e) => {
                    console.log("!!! CHUNK SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setLocalData({ ...localData, minChunkSize: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, minChunkSize: Number(e.target.value) });
                  }} />
              </FormElement>
              <FormElement>
                <FormLabel label="Max Chunk Size (in words)" />
                <FormNumberInput value={localData.maxChunkSize}
                  onChange={(e) => {
                    console.log("!!! CHUNK SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setLocalData({ ...localData, maxChunkSize: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, maxChunkSize: Number(e.target.value) });

                  }} />
              </FormElement>
            </>
          )
        }
        {
          localData.method === "sentence-based" && (
            <>
              <FormElement>
                <FormLabel label="Max Sentences" />
                <FormInput value={localData.maxSentences}
                  onChange={(e) => {
                    console.log("!!! LANGUAGE CHANGE: ", e.target.value);
                    setLocalData({ ...localData, maxSentences: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, maxSentences: Number(e.target.value) });
                  }} />
              </FormElement>
              <FormElement>
                <FormLabel label="Overlap Size (in sentences)" />
                <FormNumberInput value={localData.sentenceOverlap}
                  onChange={(e) => {
                    console.log("!!! OVERLAP SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setLocalData({ ...localData, sentenceOverlap: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, sentenceOverlap: Number(e.target.value) });
                  }}
                />
              </FormElement>
            </>
          )
        }
        {
          localData.method === "token-based" && (
            <>
              <FormElement>
                <FormLabel label="Max Tokens" />
                <FormInput value={localData.maxTokens}
                  onChange={(e) => {
                    setLocalData({ ...localData, maxTokens: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, maxTokens: Number(e.target.value) });

                  }} />
              </FormElement>
              <FormElement>
                <FormLabel label="Overlap Size (in tokens)" />
                <FormNumberInput value={localData.tokenOverlap}
                  onChange={(e) => {
                    console.log("!!! OVERLAP SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setLocalData({ ...localData, tokenOverlap: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, tokenOverlap: Number(e.target.value) });
                  }}
                />
              </FormElement>
            </>
          )
        }
        {
          localData.method === "sliding-window" && (
            <>
              <FormElement>
                <FormLabel label="Window Size (in words)" />
                <FormNumberInput value={localData.windowSize}
                  onChange={(e) => {
                    console.log("!!! CHUNK SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setLocalData({ ...localData, windowSize: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, windowSize: Number(e.target.value) });
                  }} />
              </FormElement>
              <FormElement>
                <FormLabel label="Step Size (in words)" />
                <FormNumberInput value={localData.stepSize}
                  onChange={(e) => {
                    console.log("!!! OVERLAP SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setLocalData({ ...localData, stepSize: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, stepSize: Number(e.target.value) });
                  }}
                />
              </FormElement>
            </>
          )
        }
        {
          localData.method === "hybrid" && (
            <>
              <FormElement>
                <FormLabel label="Paragraph Max Length" />
                <FormNumberInput value={localData.paragraphMaxLength}
                  onChange={(e) => {
                    console.log("!!! CHUNK SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setLocalData({ ...localData, paragraphMaxLength: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, paragraphMaxLength: Number(e.target.value) });
                  }}
                />
              </FormElement>
              <FormElement>
                <FormLabel label="Sentence Max Length" />
                <FormNumberInput value={localData.sentenceMaxLength}
                  onChange={(e) => {
                    console.log("!!! CHUNK SIZE CHANGE: ", e.target.value, parseInt(e.target.value));
                    setLocalData({ ...localData, sentenceMaxLength: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, sentenceMaxLength: Number(e.target.value) });
                  }}
                />
              </FormElement>
            </>
          )
        }
        {
          localData.method === "semantic" && (
            <FormElement>
              <FormLabel label="Number of Clusters (0 for dynamic clustering)" />
              <FormNumberInput value={localData.clusterSize}
                onChange={(e) => {
                  setLocalData({ ...localData, clusterSize: Number(e.target.value) });
                  data.onUpdateData(id, { ...localData, clusterSize: Number(e.target.value) });
                }} />
            </FormElement>
          )
        }
        {
          localData.method === "ner" && (
            <FormElement>
              <FormLabel label="Max Chunk Size" />
              <FormInput value={localData.nerMaxChunkSize}
                onChange={(e) => {
                  setLocalData({ ...localData, nerMaxChunkSize: Number(e.target.value) });
                  data.onUpdateData(id, { ...localData, nerMaxChunkSize: Number(e.target.value) });
                }} />
            </FormElement>
          )
        }
        {
          localData.method === "content-density" && (
            <>
              <FormElement>
                <FormLabel label="Min Chunk Size" />
                <FormInput value={localData.cdMinChunkSize}
                  onChange={(e) => {
                    setLocalData({ ...localData, cdMinChunkSize: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, cdMinChunkSize: Number(e.target.value) });
                  }} />
              </FormElement>
              <FormElement>
                <FormLabel label="Max Chunk Size" />
                <FormInput value={localData.cdMaxChunkSize}
                  onChange={(e) => {
                    setLocalData({ ...localData, cdMaxChunkSize: Number(e.target.value) });
                    data.onUpdateData(id, { ...localData, cdMaxChunkSize: Number(e.target.value) });
                  }} />
              </FormElement>
            </>
          )
        }
        {
          localData.method === "custom-code" && (
            <FormElement style={{ width: "400px" }}>
              <FormLabel label="Custom Python Code" />
              <FormInput value={localData.customCode}
                as="textarea"
                style={{ fontFamily: "monospace", height: "150px" }}
                onChange={(e) => {
                  setLocalData({ ...localData, customCode: e.target.value });
                  data.onUpdateData(id, { ...localData, customCode: e.target.value });
                }}
                placeholder={`# Define a function that takes in a document and returns a list of text chunks\n# The function should be named 'split_text' and take a single argument 'document'\n\ndef split_text(document):\n    # Your code here\n    return chunks`}
              />
            </FormElement>
          )
        }
      </div>
      <Handle type="target" position={Position.Left} style={{ height: "12px", width: "12px" }} />
      <Handle type="source" position={Position.Right} style={{ height: "12px", width: "12px" }} id="document-chunks" />
    </div>
  );
};

export default TextSplittingNode;
